export const getExtName = (file) => {
  if (file) {
    const ext = file?.name?.split(".");
    const extName = ext[ext?.length - 1];
    return extName;
  }
};
